import config from "react-global-configuration";
import { AESEncryptionParam, AESDecryptionParam,AESDecryption } from "./AesUtil";

export const CommonEncryptParam = (parameter) => {
    return AESEncryptionParam(parameter);
};

export const CommonDecryptParam = (cipherText) => { 
    return AESDecryptionParam(cipherText);
};




